import { BaseCaller } from "./api";

export default class BranchApi {
  private caller: BaseCaller;

  constructor(caller: BaseCaller) {
    this.caller = caller;
  }

  public listAllBranchesAdmin() {
    return this.caller.get("branch/allAdminBranches");
  }

  public listAllBranchesCompany(companyId: number) {
    return this.caller.get("branch/byCompany/" + companyId);
  }

  save(data: any) {
    if (data.id) {
      return this.caller.put(`branch/${data.id}`, data);
    }
    return this.caller.post("branch/", data);
  }

  disable(id: string) {
    return this.caller.post(`branch/${id}/inactivate`, {});
  }

  activate(id: string) {
    return this.caller.post(`branch/${id}/activate`, {});
  }
}



// WEBPACK FOOTER //
// ./src/api/branch-api.ts